import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { SERVICES, WA } from '../../constants';
import { ExternalLink, Icon, SectionTitle } from '../ui';

const Services = () => {
  return (
    <section id="servicos" className="py-12 sm:py-20 lg:py-28 bg-mesh relative">
      <div className="container mx-auto px-4">
        <SectionTitle 
          title="Nossos"
          highlight="Serviços"
          description="Serviços de estética automotiva com técnicas avançadas e produtos premium."
        />

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {SERVICES.map((service, index) => (
            <div key={index} className="card-service group p-5 sm:p-6 lg:p-8">
              {/* Icon */}
              <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-gradient-to-br from-goshine-orange to-goshine-orange-dark rounded-xl sm:rounded-2xl flex items-center justify-center mb-4 lg:mb-5">
                <Icon icon={service.icon} className="text-lg sm:text-xl lg:text-2xl text-white" />
              </div>

              {/* Title */}
              <h3 className="text-lg sm:text-xl lg:text-2xl font-bold mb-2 lg:mb-3 group-hover:text-goshine-orange transition-colors">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-sm lg:text-base text-gray-400 mb-4 lg:mb-5">
                {service.desc}
              </p>

              {/* Features */}
              <ul className="space-y-1.5 lg:space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center gap-2 text-gray-300 text-sm lg:text-base">
                    <FontAwesomeIcon icon={faCheck} className="text-goshine-orange text-xs lg:text-sm" />
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-8 sm:mt-10">
          <ExternalLink href={WA} className="btn-whatsapp inline-flex justify-center">
            <FontAwesomeIcon icon={faWhatsapp} className="text-lg" />
            Solicitar Orçamento
          </ExternalLink>
        </div>
      </div>
    </section>
  );
};

export default Services;
